interface Subject {
  _id: string;
  title: string;
  slug: string;
}

export default function getSubjectByFilter(subjects: Subject[], filters: string[]): string {
  try {
    if (filters.length > 0) {
      // Verifica se há um subject cujo slug esteja nos filters
      const filteredSubject = subjects.find(subject =>
        filters.includes(subject.slug),
      );
      // Se encontrar, retorna o subject correspondente
      if (filteredSubject) {
        return filteredSubject.title;
      }
    }

    return subjects[0].title;
  } catch (e) {
    return ""
  }
}
